import { createStore, applyMiddleware, combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import tokenReducer from "./reducers/tokenreducers";
import createAjaxReducer from "./reducers/createAjaxReducer";

let rootReducer = combineReducers({
  token: tokenReducer,
  venues: createAjaxReducer("VENUES"),
  users: createAjaxReducer("USERS"),
});

const store = createStore(rootReducer, applyMiddleware(thunkMiddleware));
window.reduxStore = store;
export default store;
